import { mount } from '../../../js/dom-lifecycle';

// the CSP blocks inline style attributes, so bar heights and fill widths are set through CSSOM
mount('[data-loyalty-value]', function () {
    this.style.setProperty('--value', `${Number(this.dataset.loyaltyValue) || 0}%`);
});
